// Tiny DOM helpers. Text is always set via textContent (never innerHTML), so
// user/friend-supplied data can never inject markup — matches the locked-origin
// / strict-CSP posture in ARCHITECTURE.md §11.

type Child = Node | string | null | undefined | false;

interface Props {
  class?: string;
  text?: string;
  onclick?: (e: MouseEvent) => void;
  [attr: string]: unknown;
}

export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: Props = {},
  ...children: Child[]
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [key, value] of Object.entries(props)) {
    if (value == null || value === false) continue;
    if (key === 'class') el.className = String(value);
    else if (key === 'text') el.textContent = String(value);
    else if (key === 'onclick') el.addEventListener('click', value as EventListener);
    else if (key === 'html') throw new Error('raw html is not allowed');
    else el.setAttribute(key, String(value));
  }
  for (const child of children) {
    if (child == null || child === false) continue;
    el.append(child instanceof Node ? child : document.createTextNode(String(child)));
  }
  return el;
}

export function mount(root: HTMLElement, node: Node): void {
  root.replaceChildren(node);
}
